import React from 'react';

import { AllFilters as AllFiltersProvider } from 'components/Filters';

import { Grid } from '@gogame/components';

import Filters from './filters';

const AllFilters = ({ open, onClose, onExited }) => {
  return (
    <AllFiltersProvider
      title={'Filters'}
      open={open}
      onClose={onClose}
      onExited={onExited}
    >
      <Grid container spacing={2}>
        <Grid item xs={4}>
          <Filters.Companies />
        </Grid>
        <Grid item xs={4}>
          <Filters.Studios />
        </Grid>
        <Grid item xs={4}>
          <Filters.Departments />
        </Grid>
        <Grid item xs={4}>
          <Filters.Managers />
        </Grid>
        <Grid item xs={4}>
          <Filters.Actions />
        </Grid>
        <Grid item xs={4}>
          <Filters.Pages />
        </Grid>
        <Grid item xs={4}>
          <Filters.Affiliates />
        </Grid>
        <Grid item xs={4}>
          <Filters.Networks />
        </Grid>
        <Grid item xs={4}>
          <Filters.Applications />
        </Grid>
        <Grid item xs={4}>
          <Filters.Show />
        </Grid>
      </Grid>
    </AllFiltersProvider>
  );
};

export default AllFilters;
